// Reference
if (document.querySelector(".JS-hp-references-swiper")) {
    new Swiper(".JS-hp-references-swiper", {
        slidesPerView: 1.15,
        spaceBetween: 16,
        navigation: {
            nextEl: ".JS-hp-references-next",
            prevEl: ".JS-hp-references-prev",
        },
        a11y: {
            prevSlideMessage: "Předchozí reference",
            nextSlideMessage: "Další reference",
        },
        breakpoints: {
            660: {
                slidesPerView: 2.2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
    });
}
